import qs from 'query-string';
import { matchPath } from 'react-router-dom';

import { loggedUser as mockLoggedUser } from 'src/mocks';
import { config, routes, pagination } from 'src/constants';
import LocalStorageService from 'src/core/services/LocalStoregeService';
import { User } from 'src/core/models';
import { PLATE_SIZES } from 'src/constants/forms';

export const getLoggedUserData = () => {
  const additionalData = !config.isDevEnv && {
    isCSR: window._lt?.user?.isCSR,
    currencyCode: window._lt?.user?.currencyCode,
    displayLang: window._lt?.user?.displayLang
  };

  return config.isDevEnv || config.isTestEnv ? new User({ ...mockLoggedUser, ...additionalData }) :
    new User({
      ...LocalStorageService.getLoggedUser(),
      ...additionalData
    });
};

export const getUserCurrency = () => {
  const user = getLoggedUserData();

  return user.currencyCode;
};

export const isCSRUser = () => {
  const user = getLoggedUserData();

  return user.isCSR;
};

export const getUserFullName = () => {
  const user = getLoggedUserData();

  return `${user.firstName} ${user.lastName}`;
};

export const redirectToLogin = () => {
  window.location.assign('/account-center/signin-identifier.html');
};

const matchPaths = (path, currentLocation) => matchPath(currentLocation, {
  path: `${config.baseRoute}${path}`,
  exact: true,
  strict: false
});

export const isRouteMatching = (route) => {
  const currentLocation = window.location.pathname;
  const matchObj = matchPaths(route, currentLocation);

  return !!(matchObj && matchObj.isExact);
};

export const getRouteId = () => {
  const currentLocation = window.location.pathname;

  const result = routes.PATHS.map((path) => matchPaths(path, currentLocation))
    .find((matchObj) => !!(matchObj && matchObj.isExact));

  return result?.params?.id;
};

export const getPaginationConfig = (
  currentPage = pagination.INITIAL_PAGE,
  pageInterval = pagination.INITIAL_ROWS_PER_PAGE,
  resourceCount = 0
) => ({
  currentPage,
  totalPage: Math.ceil(resourceCount / pageInterval),
  totalItems: resourceCount,
  pageInterval
});

export const getSentenceCase = (string) => string.charAt(0).toUpperCase() +
  string.substr(1).toLowerCase();

export const parseQueryParams = (string) => qs.parse(string);

export const getTemplateFile = (WELL_TYPE = 96) => {
  const user = getLoggedUserData();

  const TEMPLATE_96 = 'DNA_Plate_template_global_96well.xls';
  const TEMPLATE_384 = 'DNA_Plate_template_global_384well.xls';
  const BASE_DOWNLOAD_URL = '/store/shared-assets/oligo-plate/';
  const countryCode = user?.countryCode ? user.countryCode : window.iso_code;
  let document = '';

  switch (user.locale) {
    case 'en':
      if (WELL_TYPE === PLATE_SIZES.SIZE_96) {
        if (countryCode === 'jp') {
          document = 'DNA_Plate_template_JP_EN_96well.xls';
        } else if (countryCode === 'tw') {
          document = 'DNA_Plate_template_global_96well_TradChin.xls';
        } else {
          document = TEMPLATE_96;
        }
      }

      if (WELL_TYPE === PLATE_SIZES.SIZE_384) {
        document = TEMPLATE_384;
      }
      break;

    case 'ja':
      document = (WELL_TYPE === PLATE_SIZES.SIZE_96) ? 'DNA_Plate_template_JP_96well.xls' :
        TEMPLATE_384;
      break;

    case 'zh':
      document = (WELL_TYPE === PLATE_SIZES.SIZE_96) ?
        'DNA_Plate_template_global_96well_SimpChin.xls' :
        'DNA_Plate_template_global_384well_SimpChin.xls';
      break;

    case 'zt':
      document = (WELL_TYPE === PLATE_SIZES.SIZE_96) ?
        'DNA_Plate_template_global_96well_TradChin.xls' :
        'DNA_Plate_template_global_384well_TradChin.xls';
      break;
    case 'ko':
      document = (WELL_TYPE === PLATE_SIZES.SIZE_96) ?
        'DNA_Plate_template_kr_96well.xls' :
        'DNA_Plate_template_kr_384well.xls';
      break;
    default:
      document = (WELL_TYPE === PLATE_SIZES.SIZE_96) ? TEMPLATE_96 : TEMPLATE_384;
  }

  return document ? BASE_DOWNLOAD_URL + document : '';
};

export const toDecimalValue = (value) => {
  const INT_REGEX = /^-?\d+$/;
  const FLOAT_REGEX = /^\d+\.\d+$/;

  if (typeof value === 'number') {
    return parseFloat(value).toFixed(config.DECIMAL_PLACES);
  }

  if (typeof value !== 'string' || (!value.match(INT_REGEX) && !value.match(FLOAT_REGEX))) {
    return value;
  }

  return parseFloat(value).toFixed(config.DECIMAL_PLACES);
};

export const getCountryCode = () => {
  const user = getLoggedUserData();

  return window?.iso_code || user?.countryCode;
};
